import React from "react";
import styled from "@emotion/styled";

import { Drawer as MuiDrawer } from "@mui/material";

import { SidebarItemsType } from "../../types/sidebar";
import Footer from "./SidebarFooter";
import SidebarNav from "./SidebarNav";
import useAuth from "../../hooks/useAuth";

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

export type SidebarProps = {
  PaperProps: {
    style: {
      width: number;
    };
  };
  variant?: "permanent" | "persistent" | "temporary";
  open?: boolean;
  onClose?: () => void;
  items: {
    title: string;
    pages: SidebarItemsType[];
  }[];
  showFooter?: boolean;
  isDrawerOpen: boolean;
};

const Sidebar: React.FC<SidebarProps> = ({
  items,
  showFooter = true,
  isDrawerOpen,
  ...rest
}) => {
  const { user, isAuthenticated } = useAuth();

  return (
    <Drawer variant="permanent" {...rest}>
      <SidebarNav items={items} isDrawerOpen={isDrawerOpen} />
      {!!showFooter && isAuthenticated && (
        <Footer isDrawerOpen={isDrawerOpen} />
      )}
    </Drawer>
  );
};

export default Sidebar;
